import { TooltipProps, alpha } from '@mui/material';

export const getHighlightTooltipComponentProps = (
  maxWidth = 500,
): TooltipProps['componentsProps'] => {
  return {
    tooltip: {
      sx: {
        opacity: 1,
        bgcolor: 'feedback.chatBubble.primary',
        color: 'text.primary',
        maxWidth,
        border: '1px solid',
        borderColor: (theme) => alpha(theme.palette.text.primary, 0.1),
      },
    },
    arrow: {
      sx: {
        '&::before': {
          opacity: 1,
          bgcolor: 'feedback.chatBubble.primary',
          border: '1px solid',
          borderColor: (theme) => alpha(theme.palette.text.primary, 0.1),
        },
      },
    },
  };
};
